var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"inner text-left"},[_vm._t("designation"),_vm._t("heading-title")],2)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }